module.exports = "<span class=\"label label-{{labelCtrl.statusLabelClass}}\"><span ng-show=\"labelCtrl.showLabelName\">{{labelCtrl.statusName}}</span><span ng-hide=\"labelCtrl.showLabelName\">&nbsp;</span></span>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/StatusLabel.tpl.html
// module id = REEv
// module chunks = 1